/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as AuthenticatedRouteImport } from './routes/_authenticated';
import { Route as authLoginRouteImport } from './routes/(auth)/login';
import { Route as authLogoutRouteImport } from './routes/(auth)/logout';
import { Route as authSignupRouteImport } from './routes/(auth)/signup';
import { Route as publicCalculatorRouteImport } from './routes/(public)/calculator';
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/_dashboard';
import { Route as AuthenticatedOnboardingRouteRouteImport } from './routes/_authenticated/onboarding/route';
import { Route as AuthenticatedDashboardGetStartedRouteImport } from './routes/_authenticated/_dashboard/get-started';
import { Route as AuthenticatedDashboardInvitationsRouteImport } from './routes/_authenticated/_dashboard/invitations';
import { Route as AuthenticatedDashboardPreferencesRouteImport } from './routes/_authenticated/_dashboard/preferences';
import { Route as AuthenticatedDashboardSecurityRouteRouteImport } from './routes/_authenticated/_dashboard/security/route';
import { Route as AuthenticatedOauthConsentRouteImport } from './routes/_authenticated/oauth/consent';
import { Route as AuthenticatedOnboardingIndexRouteImport } from './routes/_authenticated/onboarding/index';
import { Route as AuthenticatedOnboarding1RouteImport } from './routes/_authenticated/onboarding/1';
import { Route as AuthenticatedOnboarding2RouteImport } from './routes/_authenticated/onboarding/2';
import { Route as AuthenticatedDashboardAccountsIndexRouteImport } from './routes/_authenticated/_dashboard/accounts/index';
import { Route as AuthenticatedDashboardAccountsAccountIdRouteRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/route';
import { Route as AuthenticatedDashboardAuthCallbackRouteImport } from './routes/_authenticated/_dashboard/auth/callback';
import { Route as AuthenticatedDashboardSecurityIndexRouteImport } from './routes/_authenticated/_dashboard/security/index';
import { Route as AuthenticatedDashboardSecurityConnectedAppsRouteImport } from './routes/_authenticated/_dashboard/security/connected-apps';
import { Route as AuthenticatedDashboardSecurityPasskeysRouteImport } from './routes/_authenticated/_dashboard/security/passkeys';
import { Route as AuthenticatedDashboardAccountsAccountIdBackupsRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/backups';
import { Route as AuthenticatedDashboardAccountsAccountIdBillingRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/billing';
import { Route as AuthenticatedDashboardAccountsAccountIdCloudAccessRouteRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/cloud-access/route';
import { Route as AuthenticatedDashboardAccountsAccountIdClustersRouteRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/clusters/route';
import { Route as AuthenticatedDashboardAccountsAccountIdHybridCloudRouteRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/route';
import { Route as AuthenticatedDashboardAccountsAccountIdServerlessSpacesRouteRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/route';
import { Route as AuthenticatedDashboardAccountsAccountIdSettingsRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/settings';
import { Route as AuthenticatedDashboardAccountsAccountIdCloudAccessCloudManagementKeysRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/cloud-access/cloud-management-keys';
import { Route as AuthenticatedDashboardAccountsAccountIdCloudAccessConnectedAppsRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/cloud-access/connected-apps';
import { Route as AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRouteRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles/route';
import { Route as AuthenticatedDashboardAccountsAccountIdClustersIndexRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/clusters/index';
import { Route as AuthenticatedDashboardAccountsAccountIdClustersClusterIdRouteRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/route';
import { Route as AuthenticatedDashboardAccountsAccountIdClustersCreateRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/clusters/create';
import { Route as AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdRouteRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/route';
import { Route as AuthenticatedDashboardAccountsAccountIdHybridCloudAccessRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/access';
import { Route as AuthenticatedDashboardAccountsAccountIdHybridCloudCreateRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/create';
import { Route as AuthenticatedDashboardAccountsAccountIdServerlessSpacesIndexRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/index';
import { Route as AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdRouteRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/route';
import { Route as AuthenticatedDashboardAccountsAccountIdServerlessSpacesCreateRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/create';
import { Route as AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdRouteRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles/$roleId/route';
import { Route as AuthenticatedDashboardAccountsAccountIdCloudAccessRolesAllUsersRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles/all-users';
import { Route as AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs';
import { Route as AuthenticatedDashboardAccountsAccountIdClustersClusterIdDashboardRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/dashboard';
import { Route as AuthenticatedDashboardAccountsAccountIdClustersClusterIdScaleRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/scale';
import { Route as AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdConfigurationRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/configuration';
import { Route as AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdOverviewRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/overview';
import { Route as AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs';
import { Route as AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdCreateCollectionRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/create-collection';
import { Route as AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdPermissionsRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles/$roleId/permissions';
import { Route as AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdUsersRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles/$roleId/users';
import { Route as AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsAlertsRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/alerts';
import { Route as AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsApiKeysRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/api-keys';
import { Route as AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsBackupsRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/backups';
import { Route as AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsConfigsRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/configs';
import { Route as AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/inference';
import { Route as AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsLogsRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/logs';
import { Route as AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsMetricsRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/metrics';
import { Route as AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsOverviewRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/overview';
import { Route as AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdOnboardingConnectionRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/onboarding/connection';
import { Route as AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsApiKeysRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/api-keys';
import { Route as AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsBackupsRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/backups';
import { Route as AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsRouteRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/route';
import { Route as AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsMetricsRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/metrics';
import { Route as AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsOverviewRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/overview';
import { Route as AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceInferenceModelIdRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/inference/$inferenceModelId';
import { Route as AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsIndexRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/index';
import { Route as AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameRouteRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/$collectionName/route';
import { Route as AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameInfoRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/$collectionName/info';
import { Route as AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameMetricsRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/$collectionName/metrics';
import { Route as AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNamePointsRouteImport } from './routes/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/$collectionName/points';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any);
const authLoginRoute = authLoginRouteImport.update({
  id: '/(auth)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const authLogoutRoute = authLogoutRouteImport.update({
  id: '/(auth)/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any);
const authSignupRoute = authSignupRouteImport.update({
  id: '/(auth)/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any);
const publicCalculatorRoute = publicCalculatorRouteImport.update({
  id: '/(public)/calculator',
  path: '/calculator',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedOnboardingRouteRoute =
  AuthenticatedOnboardingRouteRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedDashboardGetStartedRoute =
  AuthenticatedDashboardGetStartedRouteImport.update({
    id: '/get-started',
    path: '/get-started',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any);
const AuthenticatedDashboardInvitationsRoute =
  AuthenticatedDashboardInvitationsRouteImport.update({
    id: '/invitations',
    path: '/invitations',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any);
const AuthenticatedDashboardPreferencesRoute =
  AuthenticatedDashboardPreferencesRouteImport.update({
    id: '/preferences',
    path: '/preferences',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any);
const AuthenticatedDashboardSecurityRouteRoute =
  AuthenticatedDashboardSecurityRouteRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any);
const AuthenticatedOauthConsentRoute =
  AuthenticatedOauthConsentRouteImport.update({
    id: '/oauth/consent',
    path: '/oauth/consent',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedOnboardingIndexRoute =
  AuthenticatedOnboardingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOnboardingRouteRoute,
  } as any);
const AuthenticatedOnboarding1Route =
  AuthenticatedOnboarding1RouteImport.update({
    id: '/1',
    path: '/1',
    getParentRoute: () => AuthenticatedOnboardingRouteRoute,
  } as any);
const AuthenticatedOnboarding2Route =
  AuthenticatedOnboarding2RouteImport.update({
    id: '/2',
    path: '/2',
    getParentRoute: () => AuthenticatedOnboardingRouteRoute,
  } as any);
const AuthenticatedDashboardAccountsIndexRoute =
  AuthenticatedDashboardAccountsIndexRouteImport.update({
    id: '/accounts/',
    path: '/accounts/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any);
const AuthenticatedDashboardAccountsAccountIdRouteRoute =
  AuthenticatedDashboardAccountsAccountIdRouteRouteImport.update({
    id: '/accounts/$accountId',
    path: '/accounts/$accountId',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any);
const AuthenticatedDashboardAuthCallbackRoute =
  AuthenticatedDashboardAuthCallbackRouteImport.update({
    id: '/auth/callback',
    path: '/auth/callback',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any);
const AuthenticatedDashboardSecurityIndexRoute =
  AuthenticatedDashboardSecurityIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardSecurityRouteRoute,
  } as any);
const AuthenticatedDashboardSecurityConnectedAppsRoute =
  AuthenticatedDashboardSecurityConnectedAppsRouteImport.update({
    id: '/connected-apps',
    path: '/connected-apps',
    getParentRoute: () => AuthenticatedDashboardSecurityRouteRoute,
  } as any);
const AuthenticatedDashboardSecurityPasskeysRoute =
  AuthenticatedDashboardSecurityPasskeysRouteImport.update({
    id: '/passkeys',
    path: '/passkeys',
    getParentRoute: () => AuthenticatedDashboardSecurityRouteRoute,
  } as any);
const AuthenticatedDashboardAccountsAccountIdBackupsRoute =
  AuthenticatedDashboardAccountsAccountIdBackupsRouteImport.update({
    id: '/backups',
    path: '/backups',
    getParentRoute: () => AuthenticatedDashboardAccountsAccountIdRouteRoute,
  } as any);
const AuthenticatedDashboardAccountsAccountIdBillingRoute =
  AuthenticatedDashboardAccountsAccountIdBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedDashboardAccountsAccountIdRouteRoute,
  } as any);
const AuthenticatedDashboardAccountsAccountIdCloudAccessRouteRoute =
  AuthenticatedDashboardAccountsAccountIdCloudAccessRouteRouteImport.update({
    id: '/cloud-access',
    path: '/cloud-access',
    getParentRoute: () => AuthenticatedDashboardAccountsAccountIdRouteRoute,
  } as any);
const AuthenticatedDashboardAccountsAccountIdClustersRouteRoute =
  AuthenticatedDashboardAccountsAccountIdClustersRouteRouteImport.update({
    id: '/clusters',
    path: '/clusters',
    getParentRoute: () => AuthenticatedDashboardAccountsAccountIdRouteRoute,
  } as any);
const AuthenticatedDashboardAccountsAccountIdHybridCloudRouteRoute =
  AuthenticatedDashboardAccountsAccountIdHybridCloudRouteRouteImport.update({
    id: '/hybrid-cloud',
    path: '/hybrid-cloud',
    getParentRoute: () => AuthenticatedDashboardAccountsAccountIdRouteRoute,
  } as any);
const AuthenticatedDashboardAccountsAccountIdServerlessSpacesRouteRoute =
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesRouteRouteImport.update(
    {
      id: '/serverless-spaces',
      path: '/serverless-spaces',
      getParentRoute: () => AuthenticatedDashboardAccountsAccountIdRouteRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdSettingsRoute =
  AuthenticatedDashboardAccountsAccountIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedDashboardAccountsAccountIdRouteRoute,
  } as any);
const AuthenticatedDashboardAccountsAccountIdCloudAccessCloudManagementKeysRoute =
  AuthenticatedDashboardAccountsAccountIdCloudAccessCloudManagementKeysRouteImport.update(
    {
      id: '/cloud-management-keys',
      path: '/cloud-management-keys',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdCloudAccessRouteRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdCloudAccessConnectedAppsRoute =
  AuthenticatedDashboardAccountsAccountIdCloudAccessConnectedAppsRouteImport.update(
    {
      id: '/connected-apps',
      path: '/connected-apps',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdCloudAccessRouteRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRouteRoute =
  AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRouteRouteImport.update(
    {
      id: '/roles',
      path: '/roles',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdCloudAccessRouteRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdClustersIndexRoute =
  AuthenticatedDashboardAccountsAccountIdClustersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedDashboardAccountsAccountIdClustersRouteRoute,
  } as any);
const AuthenticatedDashboardAccountsAccountIdClustersClusterIdRouteRoute =
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdRouteRouteImport.update(
    {
      id: '/$clusterId',
      path: '/$clusterId',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdClustersRouteRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdClustersCreateRoute =
  AuthenticatedDashboardAccountsAccountIdClustersCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () =>
      AuthenticatedDashboardAccountsAccountIdClustersRouteRoute,
  } as any);
const AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdRouteRoute =
  AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdRouteRouteImport.update(
    {
      id: '/$hybridCloudEnvId',
      path: '/$hybridCloudEnvId',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdHybridCloudRouteRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdHybridCloudAccessRoute =
  AuthenticatedDashboardAccountsAccountIdHybridCloudAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () =>
      AuthenticatedDashboardAccountsAccountIdHybridCloudRouteRoute,
  } as any);
const AuthenticatedDashboardAccountsAccountIdHybridCloudCreateRoute =
  AuthenticatedDashboardAccountsAccountIdHybridCloudCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () =>
      AuthenticatedDashboardAccountsAccountIdHybridCloudRouteRoute,
  } as any);
const AuthenticatedDashboardAccountsAccountIdServerlessSpacesIndexRoute =
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdServerlessSpacesRouteRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdRouteRoute =
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdRouteRouteImport.update(
    {
      id: '/$spaceId',
      path: '/$spaceId',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdServerlessSpacesRouteRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdServerlessSpacesCreateRoute =
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesCreateRouteImport.update(
    {
      id: '/create',
      path: '/create',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdServerlessSpacesRouteRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdRouteRoute =
  AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdRouteRouteImport.update(
    {
      id: '/$roleId',
      path: '/$roleId',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRouteRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdCloudAccessRolesAllUsersRoute =
  AuthenticatedDashboardAccountsAccountIdCloudAccessRolesAllUsersRouteImport.update(
    {
      id: '/all-users',
      path: '/all-users',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRouteRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRoute =
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRouteImport.update(
    {
      id: '/_tabs',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdClustersClusterIdRouteRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdClustersClusterIdDashboardRoute =
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdDashboardRouteImport.update(
    {
      id: '/dashboard',
      path: '/dashboard',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdClustersClusterIdRouteRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdClustersClusterIdScaleRoute =
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdScaleRouteImport.update(
    {
      id: '/scale',
      path: '/scale',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdClustersClusterIdRouteRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdConfigurationRoute =
  AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdConfigurationRouteImport.update(
    {
      id: '/configuration',
      path: '/configuration',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdRouteRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdOverviewRoute =
  AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdOverviewRouteImport.update(
    {
      id: '/overview',
      path: '/overview',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdRouteRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsRoute =
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsRouteImport.update(
    {
      id: '/_tabs',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdRouteRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdCreateCollectionRoute =
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdCreateCollectionRouteImport.update(
    {
      id: '/create-collection',
      path: '/create-collection',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdRouteRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdPermissionsRoute =
  AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdPermissionsRouteImport.update(
    {
      id: '/permissions',
      path: '/permissions',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdRouteRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdUsersRoute =
  AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdUsersRouteImport.update(
    {
      id: '/users',
      path: '/users',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdRouteRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsAlertsRoute =
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsAlertsRouteImport.update(
    {
      id: '/alerts',
      path: '/alerts',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsApiKeysRoute =
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsApiKeysRouteImport.update(
    {
      id: '/api-keys',
      path: '/api-keys',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsBackupsRoute =
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsBackupsRouteImport.update(
    {
      id: '/backups',
      path: '/backups',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsConfigsRoute =
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsConfigsRouteImport.update(
    {
      id: '/configs',
      path: '/configs',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceRoute =
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceRouteImport.update(
    {
      id: '/inference',
      path: '/inference',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsLogsRoute =
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsLogsRouteImport.update(
    {
      id: '/logs',
      path: '/logs',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsMetricsRoute =
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsMetricsRouteImport.update(
    {
      id: '/metrics',
      path: '/metrics',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsOverviewRoute =
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsOverviewRouteImport.update(
    {
      id: '/overview',
      path: '/overview',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdOnboardingConnectionRoute =
  AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdOnboardingConnectionRouteImport.update(
    {
      id: '/onboarding/connection',
      path: '/onboarding/connection',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdRouteRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsApiKeysRoute =
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsApiKeysRouteImport.update(
    {
      id: '/api-keys',
      path: '/api-keys',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsBackupsRoute =
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsBackupsRouteImport.update(
    {
      id: '/backups',
      path: '/backups',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsRouteRoute =
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsRouteRouteImport.update(
    {
      id: '/collections',
      path: '/collections',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsMetricsRoute =
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsMetricsRouteImport.update(
    {
      id: '/metrics',
      path: '/metrics',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsOverviewRoute =
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsOverviewRouteImport.update(
    {
      id: '/overview',
      path: '/overview',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceInferenceModelIdRoute =
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceInferenceModelIdRouteImport.update(
    {
      id: '/$inferenceModelId',
      path: '/$inferenceModelId',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsIndexRoute =
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsRouteRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameRouteRoute =
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameRouteRouteImport.update(
    {
      id: '/$collectionName',
      path: '/$collectionName',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsRouteRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameInfoRoute =
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameInfoRouteImport.update(
    {
      id: '/info',
      path: '/info',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameRouteRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameMetricsRoute =
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameMetricsRouteImport.update(
    {
      id: '/metrics',
      path: '/metrics',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameRouteRoute,
    } as any,
  );
const AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNamePointsRoute =
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNamePointsRouteImport.update(
    {
      id: '/points',
      path: '/points',
      getParentRoute: () =>
        AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameRouteRoute,
    } as any,
  );

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/onboarding': typeof AuthenticatedOnboardingRouteRouteWithChildren;
  '/login': typeof authLoginRoute;
  '/logout': typeof authLogoutRoute;
  '/signup': typeof authSignupRoute;
  '/calculator': typeof publicCalculatorRoute;
  '/security': typeof AuthenticatedDashboardSecurityRouteRouteWithChildren;
  '/get-started': typeof AuthenticatedDashboardGetStartedRoute;
  '/invitations': typeof AuthenticatedDashboardInvitationsRoute;
  '/preferences': typeof AuthenticatedDashboardPreferencesRoute;
  '/oauth/consent': typeof AuthenticatedOauthConsentRoute;
  '/onboarding/1': typeof AuthenticatedOnboarding1Route;
  '/onboarding/2': typeof AuthenticatedOnboarding2Route;
  '/onboarding/': typeof AuthenticatedOnboardingIndexRoute;
  '/accounts/$accountId': typeof AuthenticatedDashboardAccountsAccountIdRouteRouteWithChildren;
  '/auth/callback': typeof AuthenticatedDashboardAuthCallbackRoute;
  '/security/connected-apps': typeof AuthenticatedDashboardSecurityConnectedAppsRoute;
  '/security/passkeys': typeof AuthenticatedDashboardSecurityPasskeysRoute;
  '/accounts/': typeof AuthenticatedDashboardAccountsIndexRoute;
  '/security/': typeof AuthenticatedDashboardSecurityIndexRoute;
  '/accounts/$accountId/cloud-access': typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRouteRouteWithChildren;
  '/accounts/$accountId/clusters': typeof AuthenticatedDashboardAccountsAccountIdClustersRouteRouteWithChildren;
  '/accounts/$accountId/hybrid-cloud': typeof AuthenticatedDashboardAccountsAccountIdHybridCloudRouteRouteWithChildren;
  '/accounts/$accountId/serverless-spaces': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesRouteRouteWithChildren;
  '/accounts/$accountId/backups': typeof AuthenticatedDashboardAccountsAccountIdBackupsRoute;
  '/accounts/$accountId/billing': typeof AuthenticatedDashboardAccountsAccountIdBillingRoute;
  '/accounts/$accountId/settings': typeof AuthenticatedDashboardAccountsAccountIdSettingsRoute;
  '/accounts/$accountId/cloud-access/roles': typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRouteRouteWithChildren;
  '/accounts/$accountId/clusters/$clusterId': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdRouteRouteWithChildren;
  '/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId': typeof AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdRouteRouteWithChildren;
  '/accounts/$accountId/serverless-spaces/$spaceId': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdRouteRouteWithChildren;
  '/accounts/$accountId/cloud-access/cloud-management-keys': typeof AuthenticatedDashboardAccountsAccountIdCloudAccessCloudManagementKeysRoute;
  '/accounts/$accountId/cloud-access/connected-apps': typeof AuthenticatedDashboardAccountsAccountIdCloudAccessConnectedAppsRoute;
  '/accounts/$accountId/clusters/create': typeof AuthenticatedDashboardAccountsAccountIdClustersCreateRoute;
  '/accounts/$accountId/hybrid-cloud/access': typeof AuthenticatedDashboardAccountsAccountIdHybridCloudAccessRoute;
  '/accounts/$accountId/hybrid-cloud/create': typeof AuthenticatedDashboardAccountsAccountIdHybridCloudCreateRoute;
  '/accounts/$accountId/serverless-spaces/create': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesCreateRoute;
  '/accounts/$accountId/clusters/': typeof AuthenticatedDashboardAccountsAccountIdClustersIndexRoute;
  '/accounts/$accountId/serverless-spaces/': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesIndexRoute;
  '/accounts/$accountId/cloud-access/roles/$roleId': typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdRouteRouteWithChildren;
  '/accounts/$accountId/cloud-access/roles/all-users': typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesAllUsersRoute;
  '/accounts/$accountId/clusters/$clusterId/dashboard': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdDashboardRoute;
  '/accounts/$accountId/clusters/$clusterId/scale': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdScaleRoute;
  '/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/configuration': typeof AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdConfigurationRoute;
  '/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/overview': typeof AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdOverviewRoute;
  '/accounts/$accountId/serverless-spaces/$spaceId/create-collection': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdCreateCollectionRoute;
  '/accounts/$accountId/serverless-spaces/$spaceId/collections': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsRouteRouteWithChildren;
  '/accounts/$accountId/cloud-access/roles/$roleId/permissions': typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdPermissionsRoute;
  '/accounts/$accountId/cloud-access/roles/$roleId/users': typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdUsersRoute;
  '/accounts/$accountId/clusters/$clusterId/alerts': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsAlertsRoute;
  '/accounts/$accountId/clusters/$clusterId/api-keys': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsApiKeysRoute;
  '/accounts/$accountId/clusters/$clusterId/backups': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsBackupsRoute;
  '/accounts/$accountId/clusters/$clusterId/configs': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsConfigsRoute;
  '/accounts/$accountId/clusters/$clusterId/inference': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceRouteWithChildren;
  '/accounts/$accountId/clusters/$clusterId/logs': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsLogsRoute;
  '/accounts/$accountId/clusters/$clusterId/metrics': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsMetricsRoute;
  '/accounts/$accountId/clusters/$clusterId/overview': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsOverviewRoute;
  '/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/onboarding/connection': typeof AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdOnboardingConnectionRoute;
  '/accounts/$accountId/serverless-spaces/$spaceId/api-keys': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsApiKeysRoute;
  '/accounts/$accountId/serverless-spaces/$spaceId/backups': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsBackupsRoute;
  '/accounts/$accountId/serverless-spaces/$spaceId/metrics': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsMetricsRoute;
  '/accounts/$accountId/serverless-spaces/$spaceId/overview': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsOverviewRoute;
  '/accounts/$accountId/serverless-spaces/$spaceId/collections/$collectionName': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameRouteRouteWithChildren;
  '/accounts/$accountId/clusters/$clusterId/inference/$inferenceModelId': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceInferenceModelIdRoute;
  '/accounts/$accountId/serverless-spaces/$spaceId/collections/': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsIndexRoute;
  '/accounts/$accountId/serverless-spaces/$spaceId/collections/$collectionName/info': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameInfoRoute;
  '/accounts/$accountId/serverless-spaces/$spaceId/collections/$collectionName/metrics': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameMetricsRoute;
  '/accounts/$accountId/serverless-spaces/$spaceId/collections/$collectionName/points': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNamePointsRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/login': typeof authLoginRoute;
  '/logout': typeof authLogoutRoute;
  '/signup': typeof authSignupRoute;
  '/calculator': typeof publicCalculatorRoute;
  '/get-started': typeof AuthenticatedDashboardGetStartedRoute;
  '/invitations': typeof AuthenticatedDashboardInvitationsRoute;
  '/preferences': typeof AuthenticatedDashboardPreferencesRoute;
  '/oauth/consent': typeof AuthenticatedOauthConsentRoute;
  '/onboarding/1': typeof AuthenticatedOnboarding1Route;
  '/onboarding/2': typeof AuthenticatedOnboarding2Route;
  '/onboarding': typeof AuthenticatedOnboardingIndexRoute;
  '/accounts/$accountId': typeof AuthenticatedDashboardAccountsAccountIdRouteRouteWithChildren;
  '/auth/callback': typeof AuthenticatedDashboardAuthCallbackRoute;
  '/security/connected-apps': typeof AuthenticatedDashboardSecurityConnectedAppsRoute;
  '/security/passkeys': typeof AuthenticatedDashboardSecurityPasskeysRoute;
  '/accounts': typeof AuthenticatedDashboardAccountsIndexRoute;
  '/security': typeof AuthenticatedDashboardSecurityIndexRoute;
  '/accounts/$accountId/cloud-access': typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRouteRouteWithChildren;
  '/accounts/$accountId/hybrid-cloud': typeof AuthenticatedDashboardAccountsAccountIdHybridCloudRouteRouteWithChildren;
  '/accounts/$accountId/backups': typeof AuthenticatedDashboardAccountsAccountIdBackupsRoute;
  '/accounts/$accountId/billing': typeof AuthenticatedDashboardAccountsAccountIdBillingRoute;
  '/accounts/$accountId/settings': typeof AuthenticatedDashboardAccountsAccountIdSettingsRoute;
  '/accounts/$accountId/cloud-access/roles': typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRouteRouteWithChildren;
  '/accounts/$accountId/clusters/$clusterId': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdRouteRouteWithChildren;
  '/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId': typeof AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdRouteRouteWithChildren;
  '/accounts/$accountId/serverless-spaces/$spaceId': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdRouteRouteWithChildren;
  '/accounts/$accountId/cloud-access/cloud-management-keys': typeof AuthenticatedDashboardAccountsAccountIdCloudAccessCloudManagementKeysRoute;
  '/accounts/$accountId/cloud-access/connected-apps': typeof AuthenticatedDashboardAccountsAccountIdCloudAccessConnectedAppsRoute;
  '/accounts/$accountId/clusters/create': typeof AuthenticatedDashboardAccountsAccountIdClustersCreateRoute;
  '/accounts/$accountId/hybrid-cloud/access': typeof AuthenticatedDashboardAccountsAccountIdHybridCloudAccessRoute;
  '/accounts/$accountId/hybrid-cloud/create': typeof AuthenticatedDashboardAccountsAccountIdHybridCloudCreateRoute;
  '/accounts/$accountId/serverless-spaces/create': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesCreateRoute;
  '/accounts/$accountId/clusters': typeof AuthenticatedDashboardAccountsAccountIdClustersIndexRoute;
  '/accounts/$accountId/serverless-spaces': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesIndexRoute;
  '/accounts/$accountId/cloud-access/roles/$roleId': typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdRouteRouteWithChildren;
  '/accounts/$accountId/cloud-access/roles/all-users': typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesAllUsersRoute;
  '/accounts/$accountId/clusters/$clusterId/dashboard': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdDashboardRoute;
  '/accounts/$accountId/clusters/$clusterId/scale': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdScaleRoute;
  '/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/configuration': typeof AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdConfigurationRoute;
  '/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/overview': typeof AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdOverviewRoute;
  '/accounts/$accountId/serverless-spaces/$spaceId/create-collection': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdCreateCollectionRoute;
  '/accounts/$accountId/cloud-access/roles/$roleId/permissions': typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdPermissionsRoute;
  '/accounts/$accountId/cloud-access/roles/$roleId/users': typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdUsersRoute;
  '/accounts/$accountId/clusters/$clusterId/alerts': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsAlertsRoute;
  '/accounts/$accountId/clusters/$clusterId/api-keys': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsApiKeysRoute;
  '/accounts/$accountId/clusters/$clusterId/backups': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsBackupsRoute;
  '/accounts/$accountId/clusters/$clusterId/configs': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsConfigsRoute;
  '/accounts/$accountId/clusters/$clusterId/inference': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceRouteWithChildren;
  '/accounts/$accountId/clusters/$clusterId/logs': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsLogsRoute;
  '/accounts/$accountId/clusters/$clusterId/metrics': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsMetricsRoute;
  '/accounts/$accountId/clusters/$clusterId/overview': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsOverviewRoute;
  '/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/onboarding/connection': typeof AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdOnboardingConnectionRoute;
  '/accounts/$accountId/serverless-spaces/$spaceId/api-keys': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsApiKeysRoute;
  '/accounts/$accountId/serverless-spaces/$spaceId/backups': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsBackupsRoute;
  '/accounts/$accountId/serverless-spaces/$spaceId/metrics': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsMetricsRoute;
  '/accounts/$accountId/serverless-spaces/$spaceId/overview': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsOverviewRoute;
  '/accounts/$accountId/serverless-spaces/$spaceId/collections/$collectionName': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameRouteRouteWithChildren;
  '/accounts/$accountId/clusters/$clusterId/inference/$inferenceModelId': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceInferenceModelIdRoute;
  '/accounts/$accountId/serverless-spaces/$spaceId/collections': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsIndexRoute;
  '/accounts/$accountId/serverless-spaces/$spaceId/collections/$collectionName/info': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameInfoRoute;
  '/accounts/$accountId/serverless-spaces/$spaceId/collections/$collectionName/metrics': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameMetricsRoute;
  '/accounts/$accountId/serverless-spaces/$spaceId/collections/$collectionName/points': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNamePointsRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/_authenticated': typeof AuthenticatedRouteWithChildren;
  '/_authenticated/onboarding': typeof AuthenticatedOnboardingRouteRouteWithChildren;
  '/(auth)/login': typeof authLoginRoute;
  '/(auth)/logout': typeof authLogoutRoute;
  '/(auth)/signup': typeof authSignupRoute;
  '/(public)/calculator': typeof publicCalculatorRoute;
  '/_authenticated/_dashboard': typeof AuthenticatedDashboardRouteWithChildren;
  '/_authenticated/_dashboard/security': typeof AuthenticatedDashboardSecurityRouteRouteWithChildren;
  '/_authenticated/_dashboard/get-started': typeof AuthenticatedDashboardGetStartedRoute;
  '/_authenticated/_dashboard/invitations': typeof AuthenticatedDashboardInvitationsRoute;
  '/_authenticated/_dashboard/preferences': typeof AuthenticatedDashboardPreferencesRoute;
  '/_authenticated/oauth/consent': typeof AuthenticatedOauthConsentRoute;
  '/_authenticated/onboarding/1': typeof AuthenticatedOnboarding1Route;
  '/_authenticated/onboarding/2': typeof AuthenticatedOnboarding2Route;
  '/_authenticated/onboarding/': typeof AuthenticatedOnboardingIndexRoute;
  '/_authenticated/_dashboard/accounts/$accountId': typeof AuthenticatedDashboardAccountsAccountIdRouteRouteWithChildren;
  '/_authenticated/_dashboard/auth/callback': typeof AuthenticatedDashboardAuthCallbackRoute;
  '/_authenticated/_dashboard/security/connected-apps': typeof AuthenticatedDashboardSecurityConnectedAppsRoute;
  '/_authenticated/_dashboard/security/passkeys': typeof AuthenticatedDashboardSecurityPasskeysRoute;
  '/_authenticated/_dashboard/accounts/': typeof AuthenticatedDashboardAccountsIndexRoute;
  '/_authenticated/_dashboard/security/': typeof AuthenticatedDashboardSecurityIndexRoute;
  '/_authenticated/_dashboard/accounts/$accountId/cloud-access': typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRouteRouteWithChildren;
  '/_authenticated/_dashboard/accounts/$accountId/clusters': typeof AuthenticatedDashboardAccountsAccountIdClustersRouteRouteWithChildren;
  '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud': typeof AuthenticatedDashboardAccountsAccountIdHybridCloudRouteRouteWithChildren;
  '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesRouteRouteWithChildren;
  '/_authenticated/_dashboard/accounts/$accountId/backups': typeof AuthenticatedDashboardAccountsAccountIdBackupsRoute;
  '/_authenticated/_dashboard/accounts/$accountId/billing': typeof AuthenticatedDashboardAccountsAccountIdBillingRoute;
  '/_authenticated/_dashboard/accounts/$accountId/settings': typeof AuthenticatedDashboardAccountsAccountIdSettingsRoute;
  '/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles': typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRouteRouteWithChildren;
  '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdRouteRouteWithChildren;
  '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId': typeof AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdRouteRouteWithChildren;
  '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdRouteRouteWithChildren;
  '/_authenticated/_dashboard/accounts/$accountId/cloud-access/cloud-management-keys': typeof AuthenticatedDashboardAccountsAccountIdCloudAccessCloudManagementKeysRoute;
  '/_authenticated/_dashboard/accounts/$accountId/cloud-access/connected-apps': typeof AuthenticatedDashboardAccountsAccountIdCloudAccessConnectedAppsRoute;
  '/_authenticated/_dashboard/accounts/$accountId/clusters/create': typeof AuthenticatedDashboardAccountsAccountIdClustersCreateRoute;
  '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/access': typeof AuthenticatedDashboardAccountsAccountIdHybridCloudAccessRoute;
  '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/create': typeof AuthenticatedDashboardAccountsAccountIdHybridCloudCreateRoute;
  '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/create': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesCreateRoute;
  '/_authenticated/_dashboard/accounts/$accountId/clusters/': typeof AuthenticatedDashboardAccountsAccountIdClustersIndexRoute;
  '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesIndexRoute;
  '/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles/$roleId': typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdRouteRouteWithChildren;
  '/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles/all-users': typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesAllUsersRoute;
  '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRouteWithChildren;
  '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/dashboard': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdDashboardRoute;
  '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/scale': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdScaleRoute;
  '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/configuration': typeof AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdConfigurationRoute;
  '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/overview': typeof AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdOverviewRoute;
  '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsRouteWithChildren;
  '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/create-collection': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdCreateCollectionRoute;
  '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsRouteRouteWithChildren;
  '/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles/$roleId/permissions': typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdPermissionsRoute;
  '/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles/$roleId/users': typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdUsersRoute;
  '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/alerts': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsAlertsRoute;
  '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/api-keys': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsApiKeysRoute;
  '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/backups': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsBackupsRoute;
  '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/configs': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsConfigsRoute;
  '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/inference': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceRouteWithChildren;
  '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/logs': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsLogsRoute;
  '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/metrics': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsMetricsRoute;
  '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/overview': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsOverviewRoute;
  '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/onboarding/connection': typeof AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdOnboardingConnectionRoute;
  '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/api-keys': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsApiKeysRoute;
  '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/backups': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsBackupsRoute;
  '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/metrics': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsMetricsRoute;
  '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/overview': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsOverviewRoute;
  '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/$collectionName': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameRouteRouteWithChildren;
  '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/inference/$inferenceModelId': typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceInferenceModelIdRoute;
  '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsIndexRoute;
  '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/$collectionName/info': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameInfoRoute;
  '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/$collectionName/metrics': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameMetricsRoute;
  '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/$collectionName/points': typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNamePointsRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/onboarding'
    | '/login'
    | '/logout'
    | '/signup'
    | '/calculator'
    | '/security'
    | '/get-started'
    | '/invitations'
    | '/preferences'
    | '/oauth/consent'
    | '/onboarding/1'
    | '/onboarding/2'
    | '/onboarding/'
    | '/accounts/$accountId'
    | '/auth/callback'
    | '/security/connected-apps'
    | '/security/passkeys'
    | '/accounts/'
    | '/security/'
    | '/accounts/$accountId/cloud-access'
    | '/accounts/$accountId/clusters'
    | '/accounts/$accountId/hybrid-cloud'
    | '/accounts/$accountId/serverless-spaces'
    | '/accounts/$accountId/backups'
    | '/accounts/$accountId/billing'
    | '/accounts/$accountId/settings'
    | '/accounts/$accountId/cloud-access/roles'
    | '/accounts/$accountId/clusters/$clusterId'
    | '/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId'
    | '/accounts/$accountId/serverless-spaces/$spaceId'
    | '/accounts/$accountId/cloud-access/cloud-management-keys'
    | '/accounts/$accountId/cloud-access/connected-apps'
    | '/accounts/$accountId/clusters/create'
    | '/accounts/$accountId/hybrid-cloud/access'
    | '/accounts/$accountId/hybrid-cloud/create'
    | '/accounts/$accountId/serverless-spaces/create'
    | '/accounts/$accountId/clusters/'
    | '/accounts/$accountId/serverless-spaces/'
    | '/accounts/$accountId/cloud-access/roles/$roleId'
    | '/accounts/$accountId/cloud-access/roles/all-users'
    | '/accounts/$accountId/clusters/$clusterId/dashboard'
    | '/accounts/$accountId/clusters/$clusterId/scale'
    | '/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/configuration'
    | '/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/overview'
    | '/accounts/$accountId/serverless-spaces/$spaceId/create-collection'
    | '/accounts/$accountId/serverless-spaces/$spaceId/collections'
    | '/accounts/$accountId/cloud-access/roles/$roleId/permissions'
    | '/accounts/$accountId/cloud-access/roles/$roleId/users'
    | '/accounts/$accountId/clusters/$clusterId/alerts'
    | '/accounts/$accountId/clusters/$clusterId/api-keys'
    | '/accounts/$accountId/clusters/$clusterId/backups'
    | '/accounts/$accountId/clusters/$clusterId/configs'
    | '/accounts/$accountId/clusters/$clusterId/inference'
    | '/accounts/$accountId/clusters/$clusterId/logs'
    | '/accounts/$accountId/clusters/$clusterId/metrics'
    | '/accounts/$accountId/clusters/$clusterId/overview'
    | '/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/onboarding/connection'
    | '/accounts/$accountId/serverless-spaces/$spaceId/api-keys'
    | '/accounts/$accountId/serverless-spaces/$spaceId/backups'
    | '/accounts/$accountId/serverless-spaces/$spaceId/metrics'
    | '/accounts/$accountId/serverless-spaces/$spaceId/overview'
    | '/accounts/$accountId/serverless-spaces/$spaceId/collections/$collectionName'
    | '/accounts/$accountId/clusters/$clusterId/inference/$inferenceModelId'
    | '/accounts/$accountId/serverless-spaces/$spaceId/collections/'
    | '/accounts/$accountId/serverless-spaces/$spaceId/collections/$collectionName/info'
    | '/accounts/$accountId/serverless-spaces/$spaceId/collections/$collectionName/metrics'
    | '/accounts/$accountId/serverless-spaces/$spaceId/collections/$collectionName/points';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/login'
    | '/logout'
    | '/signup'
    | '/calculator'
    | '/get-started'
    | '/invitations'
    | '/preferences'
    | '/oauth/consent'
    | '/onboarding/1'
    | '/onboarding/2'
    | '/onboarding'
    | '/accounts/$accountId'
    | '/auth/callback'
    | '/security/connected-apps'
    | '/security/passkeys'
    | '/accounts'
    | '/security'
    | '/accounts/$accountId/cloud-access'
    | '/accounts/$accountId/hybrid-cloud'
    | '/accounts/$accountId/backups'
    | '/accounts/$accountId/billing'
    | '/accounts/$accountId/settings'
    | '/accounts/$accountId/cloud-access/roles'
    | '/accounts/$accountId/clusters/$clusterId'
    | '/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId'
    | '/accounts/$accountId/serverless-spaces/$spaceId'
    | '/accounts/$accountId/cloud-access/cloud-management-keys'
    | '/accounts/$accountId/cloud-access/connected-apps'
    | '/accounts/$accountId/clusters/create'
    | '/accounts/$accountId/hybrid-cloud/access'
    | '/accounts/$accountId/hybrid-cloud/create'
    | '/accounts/$accountId/serverless-spaces/create'
    | '/accounts/$accountId/clusters'
    | '/accounts/$accountId/serverless-spaces'
    | '/accounts/$accountId/cloud-access/roles/$roleId'
    | '/accounts/$accountId/cloud-access/roles/all-users'
    | '/accounts/$accountId/clusters/$clusterId/dashboard'
    | '/accounts/$accountId/clusters/$clusterId/scale'
    | '/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/configuration'
    | '/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/overview'
    | '/accounts/$accountId/serverless-spaces/$spaceId/create-collection'
    | '/accounts/$accountId/cloud-access/roles/$roleId/permissions'
    | '/accounts/$accountId/cloud-access/roles/$roleId/users'
    | '/accounts/$accountId/clusters/$clusterId/alerts'
    | '/accounts/$accountId/clusters/$clusterId/api-keys'
    | '/accounts/$accountId/clusters/$clusterId/backups'
    | '/accounts/$accountId/clusters/$clusterId/configs'
    | '/accounts/$accountId/clusters/$clusterId/inference'
    | '/accounts/$accountId/clusters/$clusterId/logs'
    | '/accounts/$accountId/clusters/$clusterId/metrics'
    | '/accounts/$accountId/clusters/$clusterId/overview'
    | '/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/onboarding/connection'
    | '/accounts/$accountId/serverless-spaces/$spaceId/api-keys'
    | '/accounts/$accountId/serverless-spaces/$spaceId/backups'
    | '/accounts/$accountId/serverless-spaces/$spaceId/metrics'
    | '/accounts/$accountId/serverless-spaces/$spaceId/overview'
    | '/accounts/$accountId/serverless-spaces/$spaceId/collections/$collectionName'
    | '/accounts/$accountId/clusters/$clusterId/inference/$inferenceModelId'
    | '/accounts/$accountId/serverless-spaces/$spaceId/collections'
    | '/accounts/$accountId/serverless-spaces/$spaceId/collections/$collectionName/info'
    | '/accounts/$accountId/serverless-spaces/$spaceId/collections/$collectionName/metrics'
    | '/accounts/$accountId/serverless-spaces/$spaceId/collections/$collectionName/points';
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_authenticated/onboarding'
    | '/(auth)/login'
    | '/(auth)/logout'
    | '/(auth)/signup'
    | '/(public)/calculator'
    | '/_authenticated/_dashboard'
    | '/_authenticated/_dashboard/security'
    | '/_authenticated/_dashboard/get-started'
    | '/_authenticated/_dashboard/invitations'
    | '/_authenticated/_dashboard/preferences'
    | '/_authenticated/oauth/consent'
    | '/_authenticated/onboarding/1'
    | '/_authenticated/onboarding/2'
    | '/_authenticated/onboarding/'
    | '/_authenticated/_dashboard/accounts/$accountId'
    | '/_authenticated/_dashboard/auth/callback'
    | '/_authenticated/_dashboard/security/connected-apps'
    | '/_authenticated/_dashboard/security/passkeys'
    | '/_authenticated/_dashboard/accounts/'
    | '/_authenticated/_dashboard/security/'
    | '/_authenticated/_dashboard/accounts/$accountId/cloud-access'
    | '/_authenticated/_dashboard/accounts/$accountId/clusters'
    | '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud'
    | '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces'
    | '/_authenticated/_dashboard/accounts/$accountId/backups'
    | '/_authenticated/_dashboard/accounts/$accountId/billing'
    | '/_authenticated/_dashboard/accounts/$accountId/settings'
    | '/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles'
    | '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId'
    | '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId'
    | '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId'
    | '/_authenticated/_dashboard/accounts/$accountId/cloud-access/cloud-management-keys'
    | '/_authenticated/_dashboard/accounts/$accountId/cloud-access/connected-apps'
    | '/_authenticated/_dashboard/accounts/$accountId/clusters/create'
    | '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/access'
    | '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/create'
    | '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/create'
    | '/_authenticated/_dashboard/accounts/$accountId/clusters/'
    | '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/'
    | '/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles/$roleId'
    | '/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles/all-users'
    | '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs'
    | '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/dashboard'
    | '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/scale'
    | '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/configuration'
    | '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/overview'
    | '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs'
    | '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/create-collection'
    | '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections'
    | '/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles/$roleId/permissions'
    | '/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles/$roleId/users'
    | '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/alerts'
    | '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/api-keys'
    | '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/backups'
    | '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/configs'
    | '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/inference'
    | '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/logs'
    | '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/metrics'
    | '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/overview'
    | '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/onboarding/connection'
    | '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/api-keys'
    | '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/backups'
    | '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/metrics'
    | '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/overview'
    | '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/$collectionName'
    | '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/inference/$inferenceModelId'
    | '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/'
    | '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/$collectionName/info'
    | '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/$collectionName/metrics'
    | '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/$collectionName/points';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren;
  authLoginRoute: typeof authLoginRoute;
  authLogoutRoute: typeof authLogoutRoute;
  authSignupRoute: typeof authSignupRoute;
  publicCalculatorRoute: typeof publicCalculatorRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated': {
      id: '/_authenticated';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AuthenticatedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(auth)/login': {
      id: '/(auth)/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof authLoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(auth)/logout': {
      id: '/(auth)/logout';
      path: '/logout';
      fullPath: '/logout';
      preLoaderRoute: typeof authLogoutRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(auth)/signup': {
      id: '/(auth)/signup';
      path: '/signup';
      fullPath: '/signup';
      preLoaderRoute: typeof authSignupRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/calculator': {
      id: '/(public)/calculator';
      path: '/calculator';
      fullPath: '/calculator';
      preLoaderRoute: typeof publicCalculatorRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated/_dashboard': {
      id: '/_authenticated/_dashboard';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/onboarding': {
      id: '/_authenticated/onboarding';
      path: '/onboarding';
      fullPath: '/onboarding';
      preLoaderRoute: typeof AuthenticatedOnboardingRouteRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/_dashboard/get-started': {
      id: '/_authenticated/_dashboard/get-started';
      path: '/get-started';
      fullPath: '/get-started';
      preLoaderRoute: typeof AuthenticatedDashboardGetStartedRouteImport;
      parentRoute: typeof AuthenticatedDashboardRoute;
    };
    '/_authenticated/_dashboard/invitations': {
      id: '/_authenticated/_dashboard/invitations';
      path: '/invitations';
      fullPath: '/invitations';
      preLoaderRoute: typeof AuthenticatedDashboardInvitationsRouteImport;
      parentRoute: typeof AuthenticatedDashboardRoute;
    };
    '/_authenticated/_dashboard/preferences': {
      id: '/_authenticated/_dashboard/preferences';
      path: '/preferences';
      fullPath: '/preferences';
      preLoaderRoute: typeof AuthenticatedDashboardPreferencesRouteImport;
      parentRoute: typeof AuthenticatedDashboardRoute;
    };
    '/_authenticated/_dashboard/security': {
      id: '/_authenticated/_dashboard/security';
      path: '/security';
      fullPath: '/security';
      preLoaderRoute: typeof AuthenticatedDashboardSecurityRouteRouteImport;
      parentRoute: typeof AuthenticatedDashboardRoute;
    };
    '/_authenticated/oauth/consent': {
      id: '/_authenticated/oauth/consent';
      path: '/oauth/consent';
      fullPath: '/oauth/consent';
      preLoaderRoute: typeof AuthenticatedOauthConsentRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/onboarding/': {
      id: '/_authenticated/onboarding/';
      path: '/';
      fullPath: '/onboarding/';
      preLoaderRoute: typeof AuthenticatedOnboardingIndexRouteImport;
      parentRoute: typeof AuthenticatedOnboardingRouteRoute;
    };
    '/_authenticated/onboarding/1': {
      id: '/_authenticated/onboarding/1';
      path: '/1';
      fullPath: '/onboarding/1';
      preLoaderRoute: typeof AuthenticatedOnboarding1RouteImport;
      parentRoute: typeof AuthenticatedOnboardingRouteRoute;
    };
    '/_authenticated/onboarding/2': {
      id: '/_authenticated/onboarding/2';
      path: '/2';
      fullPath: '/onboarding/2';
      preLoaderRoute: typeof AuthenticatedOnboarding2RouteImport;
      parentRoute: typeof AuthenticatedOnboardingRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/': {
      id: '/_authenticated/_dashboard/accounts/';
      path: '/accounts';
      fullPath: '/accounts/';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsIndexRouteImport;
      parentRoute: typeof AuthenticatedDashboardRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId': {
      id: '/_authenticated/_dashboard/accounts/$accountId';
      path: '/accounts/$accountId';
      fullPath: '/accounts/$accountId';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdRouteRouteImport;
      parentRoute: typeof AuthenticatedDashboardRoute;
    };
    '/_authenticated/_dashboard/auth/callback': {
      id: '/_authenticated/_dashboard/auth/callback';
      path: '/auth/callback';
      fullPath: '/auth/callback';
      preLoaderRoute: typeof AuthenticatedDashboardAuthCallbackRouteImport;
      parentRoute: typeof AuthenticatedDashboardRoute;
    };
    '/_authenticated/_dashboard/security/': {
      id: '/_authenticated/_dashboard/security/';
      path: '/';
      fullPath: '/security/';
      preLoaderRoute: typeof AuthenticatedDashboardSecurityIndexRouteImport;
      parentRoute: typeof AuthenticatedDashboardSecurityRouteRoute;
    };
    '/_authenticated/_dashboard/security/connected-apps': {
      id: '/_authenticated/_dashboard/security/connected-apps';
      path: '/connected-apps';
      fullPath: '/security/connected-apps';
      preLoaderRoute: typeof AuthenticatedDashboardSecurityConnectedAppsRouteImport;
      parentRoute: typeof AuthenticatedDashboardSecurityRouteRoute;
    };
    '/_authenticated/_dashboard/security/passkeys': {
      id: '/_authenticated/_dashboard/security/passkeys';
      path: '/passkeys';
      fullPath: '/security/passkeys';
      preLoaderRoute: typeof AuthenticatedDashboardSecurityPasskeysRouteImport;
      parentRoute: typeof AuthenticatedDashboardSecurityRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/backups': {
      id: '/_authenticated/_dashboard/accounts/$accountId/backups';
      path: '/backups';
      fullPath: '/accounts/$accountId/backups';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdBackupsRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/billing': {
      id: '/_authenticated/_dashboard/accounts/$accountId/billing';
      path: '/billing';
      fullPath: '/accounts/$accountId/billing';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdBillingRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/cloud-access': {
      id: '/_authenticated/_dashboard/accounts/$accountId/cloud-access';
      path: '/cloud-access';
      fullPath: '/accounts/$accountId/cloud-access';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRouteRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/clusters': {
      id: '/_authenticated/_dashboard/accounts/$accountId/clusters';
      path: '/clusters';
      fullPath: '/accounts/$accountId/clusters';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersRouteRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud': {
      id: '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud';
      path: '/hybrid-cloud';
      fullPath: '/accounts/$accountId/hybrid-cloud';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdHybridCloudRouteRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces': {
      id: '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces';
      path: '/serverless-spaces';
      fullPath: '/accounts/$accountId/serverless-spaces';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesRouteRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/settings': {
      id: '/_authenticated/_dashboard/accounts/$accountId/settings';
      path: '/settings';
      fullPath: '/accounts/$accountId/settings';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdSettingsRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/cloud-access/cloud-management-keys': {
      id: '/_authenticated/_dashboard/accounts/$accountId/cloud-access/cloud-management-keys';
      path: '/cloud-management-keys';
      fullPath: '/accounts/$accountId/cloud-access/cloud-management-keys';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdCloudAccessCloudManagementKeysRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/cloud-access/connected-apps': {
      id: '/_authenticated/_dashboard/accounts/$accountId/cloud-access/connected-apps';
      path: '/connected-apps';
      fullPath: '/accounts/$accountId/cloud-access/connected-apps';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdCloudAccessConnectedAppsRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles': {
      id: '/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles';
      path: '/roles';
      fullPath: '/accounts/$accountId/cloud-access/roles';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRouteRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/clusters/': {
      id: '/_authenticated/_dashboard/accounts/$accountId/clusters/';
      path: '/';
      fullPath: '/accounts/$accountId/clusters/';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersIndexRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId': {
      id: '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId';
      path: '/$clusterId';
      fullPath: '/accounts/$accountId/clusters/$clusterId';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdRouteRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/clusters/create': {
      id: '/_authenticated/_dashboard/accounts/$accountId/clusters/create';
      path: '/create';
      fullPath: '/accounts/$accountId/clusters/create';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersCreateRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId': {
      id: '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId';
      path: '/$hybridCloudEnvId';
      fullPath: '/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdRouteRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdHybridCloudRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/access': {
      id: '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/access';
      path: '/access';
      fullPath: '/accounts/$accountId/hybrid-cloud/access';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdHybridCloudAccessRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdHybridCloudRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/create': {
      id: '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/create';
      path: '/create';
      fullPath: '/accounts/$accountId/hybrid-cloud/create';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdHybridCloudCreateRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdHybridCloudRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/': {
      id: '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/';
      path: '/';
      fullPath: '/accounts/$accountId/serverless-spaces/';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesIndexRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId': {
      id: '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId';
      path: '/$spaceId';
      fullPath: '/accounts/$accountId/serverless-spaces/$spaceId';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdRouteRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/create': {
      id: '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/create';
      path: '/create';
      fullPath: '/accounts/$accountId/serverless-spaces/create';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesCreateRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles/$roleId': {
      id: '/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles/$roleId';
      path: '/$roleId';
      fullPath: '/accounts/$accountId/cloud-access/roles/$roleId';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdRouteRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles/all-users': {
      id: '/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles/all-users';
      path: '/all-users';
      fullPath: '/accounts/$accountId/cloud-access/roles/all-users';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesAllUsersRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs': {
      id: '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs';
      path: '';
      fullPath: '/accounts/$accountId/clusters/$clusterId';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/dashboard': {
      id: '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/dashboard';
      path: '/dashboard';
      fullPath: '/accounts/$accountId/clusters/$clusterId/dashboard';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdDashboardRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/scale': {
      id: '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/scale';
      path: '/scale';
      fullPath: '/accounts/$accountId/clusters/$clusterId/scale';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdScaleRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/configuration': {
      id: '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/configuration';
      path: '/configuration';
      fullPath: '/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/configuration';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdConfigurationRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/overview': {
      id: '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/overview';
      path: '/overview';
      fullPath: '/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/overview';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdOverviewRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs': {
      id: '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs';
      path: '';
      fullPath: '/accounts/$accountId/serverless-spaces/$spaceId';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/create-collection': {
      id: '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/create-collection';
      path: '/create-collection';
      fullPath: '/accounts/$accountId/serverless-spaces/$spaceId/create-collection';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdCreateCollectionRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles/$roleId/permissions': {
      id: '/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles/$roleId/permissions';
      path: '/permissions';
      fullPath: '/accounts/$accountId/cloud-access/roles/$roleId/permissions';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdPermissionsRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles/$roleId/users': {
      id: '/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles/$roleId/users';
      path: '/users';
      fullPath: '/accounts/$accountId/cloud-access/roles/$roleId/users';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdUsersRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/alerts': {
      id: '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/alerts';
      path: '/alerts';
      fullPath: '/accounts/$accountId/clusters/$clusterId/alerts';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsAlertsRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/api-keys': {
      id: '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/api-keys';
      path: '/api-keys';
      fullPath: '/accounts/$accountId/clusters/$clusterId/api-keys';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsApiKeysRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/backups': {
      id: '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/backups';
      path: '/backups';
      fullPath: '/accounts/$accountId/clusters/$clusterId/backups';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsBackupsRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/configs': {
      id: '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/configs';
      path: '/configs';
      fullPath: '/accounts/$accountId/clusters/$clusterId/configs';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsConfigsRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/inference': {
      id: '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/inference';
      path: '/inference';
      fullPath: '/accounts/$accountId/clusters/$clusterId/inference';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/logs': {
      id: '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/logs';
      path: '/logs';
      fullPath: '/accounts/$accountId/clusters/$clusterId/logs';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsLogsRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/metrics': {
      id: '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/metrics';
      path: '/metrics';
      fullPath: '/accounts/$accountId/clusters/$clusterId/metrics';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsMetricsRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/overview': {
      id: '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/overview';
      path: '/overview';
      fullPath: '/accounts/$accountId/clusters/$clusterId/overview';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsOverviewRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/onboarding/connection': {
      id: '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/onboarding/connection';
      path: '/onboarding/connection';
      fullPath: '/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/onboarding/connection';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdOnboardingConnectionRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/api-keys': {
      id: '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/api-keys';
      path: '/api-keys';
      fullPath: '/accounts/$accountId/serverless-spaces/$spaceId/api-keys';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsApiKeysRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/backups': {
      id: '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/backups';
      path: '/backups';
      fullPath: '/accounts/$accountId/serverless-spaces/$spaceId/backups';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsBackupsRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections': {
      id: '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections';
      path: '/collections';
      fullPath: '/accounts/$accountId/serverless-spaces/$spaceId/collections';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsRouteRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/metrics': {
      id: '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/metrics';
      path: '/metrics';
      fullPath: '/accounts/$accountId/serverless-spaces/$spaceId/metrics';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsMetricsRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/overview': {
      id: '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/overview';
      path: '/overview';
      fullPath: '/accounts/$accountId/serverless-spaces/$spaceId/overview';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsOverviewRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/inference/$inferenceModelId': {
      id: '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/inference/$inferenceModelId';
      path: '/$inferenceModelId';
      fullPath: '/accounts/$accountId/clusters/$clusterId/inference/$inferenceModelId';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceInferenceModelIdRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/': {
      id: '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/';
      path: '/';
      fullPath: '/accounts/$accountId/serverless-spaces/$spaceId/collections/';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsIndexRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/$collectionName': {
      id: '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/$collectionName';
      path: '/$collectionName';
      fullPath: '/accounts/$accountId/serverless-spaces/$spaceId/collections/$collectionName';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameRouteRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/$collectionName/info': {
      id: '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/$collectionName/info';
      path: '/info';
      fullPath: '/accounts/$accountId/serverless-spaces/$spaceId/collections/$collectionName/info';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameInfoRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/$collectionName/metrics': {
      id: '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/$collectionName/metrics';
      path: '/metrics';
      fullPath: '/accounts/$accountId/serverless-spaces/$spaceId/collections/$collectionName/metrics';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameMetricsRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameRouteRoute;
    };
    '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/$collectionName/points': {
      id: '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/$collectionName/points';
      path: '/points';
      fullPath: '/accounts/$accountId/serverless-spaces/$spaceId/collections/$collectionName/points';
      preLoaderRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNamePointsRouteImport;
      parentRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameRouteRoute;
    };
  }
}

interface AuthenticatedOnboardingRouteRouteChildren {
  AuthenticatedOnboarding1Route: typeof AuthenticatedOnboarding1Route;
  AuthenticatedOnboarding2Route: typeof AuthenticatedOnboarding2Route;
  AuthenticatedOnboardingIndexRoute: typeof AuthenticatedOnboardingIndexRoute;
}

const AuthenticatedOnboardingRouteRouteChildren: AuthenticatedOnboardingRouteRouteChildren =
  {
    AuthenticatedOnboarding1Route: AuthenticatedOnboarding1Route,
    AuthenticatedOnboarding2Route: AuthenticatedOnboarding2Route,
    AuthenticatedOnboardingIndexRoute: AuthenticatedOnboardingIndexRoute,
  };

const AuthenticatedOnboardingRouteRouteWithChildren =
  AuthenticatedOnboardingRouteRoute._addFileChildren(
    AuthenticatedOnboardingRouteRouteChildren,
  );

interface AuthenticatedDashboardSecurityRouteRouteChildren {
  AuthenticatedDashboardSecurityConnectedAppsRoute: typeof AuthenticatedDashboardSecurityConnectedAppsRoute;
  AuthenticatedDashboardSecurityPasskeysRoute: typeof AuthenticatedDashboardSecurityPasskeysRoute;
  AuthenticatedDashboardSecurityIndexRoute: typeof AuthenticatedDashboardSecurityIndexRoute;
}

const AuthenticatedDashboardSecurityRouteRouteChildren: AuthenticatedDashboardSecurityRouteRouteChildren =
  {
    AuthenticatedDashboardSecurityConnectedAppsRoute:
      AuthenticatedDashboardSecurityConnectedAppsRoute,
    AuthenticatedDashboardSecurityPasskeysRoute:
      AuthenticatedDashboardSecurityPasskeysRoute,
    AuthenticatedDashboardSecurityIndexRoute:
      AuthenticatedDashboardSecurityIndexRoute,
  };

const AuthenticatedDashboardSecurityRouteRouteWithChildren =
  AuthenticatedDashboardSecurityRouteRoute._addFileChildren(
    AuthenticatedDashboardSecurityRouteRouteChildren,
  );

interface AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdRouteRouteChildren {
  AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdPermissionsRoute: typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdPermissionsRoute;
  AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdUsersRoute: typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdUsersRoute;
}

const AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdRouteRouteChildren: AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdRouteRouteChildren =
  {
    AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdPermissionsRoute:
      AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdPermissionsRoute,
    AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdUsersRoute:
      AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdUsersRoute,
  };

const AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdRouteRouteWithChildren =
  AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdRouteRoute._addFileChildren(
    AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdRouteRouteChildren,
  );

interface AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRouteRouteChildren {
  AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdRouteRoute: typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdRouteRouteWithChildren;
  AuthenticatedDashboardAccountsAccountIdCloudAccessRolesAllUsersRoute: typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesAllUsersRoute;
}

const AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRouteRouteChildren: AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRouteRouteChildren =
  {
    AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdRouteRoute:
      AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRoleIdRouteRouteWithChildren,
    AuthenticatedDashboardAccountsAccountIdCloudAccessRolesAllUsersRoute:
      AuthenticatedDashboardAccountsAccountIdCloudAccessRolesAllUsersRoute,
  };

const AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRouteRouteWithChildren =
  AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRouteRoute._addFileChildren(
    AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRouteRouteChildren,
  );

interface AuthenticatedDashboardAccountsAccountIdCloudAccessRouteRouteChildren {
  AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRouteRoute: typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRouteRouteWithChildren;
  AuthenticatedDashboardAccountsAccountIdCloudAccessCloudManagementKeysRoute: typeof AuthenticatedDashboardAccountsAccountIdCloudAccessCloudManagementKeysRoute;
  AuthenticatedDashboardAccountsAccountIdCloudAccessConnectedAppsRoute: typeof AuthenticatedDashboardAccountsAccountIdCloudAccessConnectedAppsRoute;
}

const AuthenticatedDashboardAccountsAccountIdCloudAccessRouteRouteChildren: AuthenticatedDashboardAccountsAccountIdCloudAccessRouteRouteChildren =
  {
    AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRouteRoute:
      AuthenticatedDashboardAccountsAccountIdCloudAccessRolesRouteRouteWithChildren,
    AuthenticatedDashboardAccountsAccountIdCloudAccessCloudManagementKeysRoute:
      AuthenticatedDashboardAccountsAccountIdCloudAccessCloudManagementKeysRoute,
    AuthenticatedDashboardAccountsAccountIdCloudAccessConnectedAppsRoute:
      AuthenticatedDashboardAccountsAccountIdCloudAccessConnectedAppsRoute,
  };

const AuthenticatedDashboardAccountsAccountIdCloudAccessRouteRouteWithChildren =
  AuthenticatedDashboardAccountsAccountIdCloudAccessRouteRoute._addFileChildren(
    AuthenticatedDashboardAccountsAccountIdCloudAccessRouteRouteChildren,
  );

interface AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceRouteChildren {
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceInferenceModelIdRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceInferenceModelIdRoute;
}

const AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceRouteChildren: AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceRouteChildren =
  {
    AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceInferenceModelIdRoute:
      AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceInferenceModelIdRoute,
  };

const AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceRouteWithChildren =
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceRoute._addFileChildren(
    AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceRouteChildren,
  );

interface AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRouteChildren {
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsAlertsRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsAlertsRoute;
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsApiKeysRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsApiKeysRoute;
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsBackupsRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsBackupsRoute;
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsConfigsRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsConfigsRoute;
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceRouteWithChildren;
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsLogsRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsLogsRoute;
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsMetricsRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsMetricsRoute;
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsOverviewRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsOverviewRoute;
}

const AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRouteChildren: AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRouteChildren =
  {
    AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsAlertsRoute:
      AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsAlertsRoute,
    AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsApiKeysRoute:
      AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsApiKeysRoute,
    AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsBackupsRoute:
      AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsBackupsRoute,
    AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsConfigsRoute:
      AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsConfigsRoute,
    AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceRoute:
      AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsInferenceRouteWithChildren,
    AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsLogsRoute:
      AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsLogsRoute,
    AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsMetricsRoute:
      AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsMetricsRoute,
    AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsOverviewRoute:
      AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsOverviewRoute,
  };

const AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRouteWithChildren =
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRoute._addFileChildren(
    AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRouteChildren,
  );

interface AuthenticatedDashboardAccountsAccountIdClustersClusterIdRouteRouteChildren {
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRouteWithChildren;
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdDashboardRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdDashboardRoute;
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdScaleRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdScaleRoute;
}

const AuthenticatedDashboardAccountsAccountIdClustersClusterIdRouteRouteChildren: AuthenticatedDashboardAccountsAccountIdClustersClusterIdRouteRouteChildren =
  {
    AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRoute:
      AuthenticatedDashboardAccountsAccountIdClustersClusterIdTabsRouteWithChildren,
    AuthenticatedDashboardAccountsAccountIdClustersClusterIdDashboardRoute:
      AuthenticatedDashboardAccountsAccountIdClustersClusterIdDashboardRoute,
    AuthenticatedDashboardAccountsAccountIdClustersClusterIdScaleRoute:
      AuthenticatedDashboardAccountsAccountIdClustersClusterIdScaleRoute,
  };

const AuthenticatedDashboardAccountsAccountIdClustersClusterIdRouteRouteWithChildren =
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdRouteRoute._addFileChildren(
    AuthenticatedDashboardAccountsAccountIdClustersClusterIdRouteRouteChildren,
  );

interface AuthenticatedDashboardAccountsAccountIdClustersRouteRouteChildren {
  AuthenticatedDashboardAccountsAccountIdClustersClusterIdRouteRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersClusterIdRouteRouteWithChildren;
  AuthenticatedDashboardAccountsAccountIdClustersCreateRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersCreateRoute;
  AuthenticatedDashboardAccountsAccountIdClustersIndexRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersIndexRoute;
}

const AuthenticatedDashboardAccountsAccountIdClustersRouteRouteChildren: AuthenticatedDashboardAccountsAccountIdClustersRouteRouteChildren =
  {
    AuthenticatedDashboardAccountsAccountIdClustersClusterIdRouteRoute:
      AuthenticatedDashboardAccountsAccountIdClustersClusterIdRouteRouteWithChildren,
    AuthenticatedDashboardAccountsAccountIdClustersCreateRoute:
      AuthenticatedDashboardAccountsAccountIdClustersCreateRoute,
    AuthenticatedDashboardAccountsAccountIdClustersIndexRoute:
      AuthenticatedDashboardAccountsAccountIdClustersIndexRoute,
  };

const AuthenticatedDashboardAccountsAccountIdClustersRouteRouteWithChildren =
  AuthenticatedDashboardAccountsAccountIdClustersRouteRoute._addFileChildren(
    AuthenticatedDashboardAccountsAccountIdClustersRouteRouteChildren,
  );

interface AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdRouteRouteChildren {
  AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdConfigurationRoute: typeof AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdConfigurationRoute;
  AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdOverviewRoute: typeof AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdOverviewRoute;
  AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdOnboardingConnectionRoute: typeof AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdOnboardingConnectionRoute;
}

const AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdRouteRouteChildren: AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdRouteRouteChildren =
  {
    AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdConfigurationRoute:
      AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdConfigurationRoute,
    AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdOverviewRoute:
      AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdOverviewRoute,
    AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdOnboardingConnectionRoute:
      AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdOnboardingConnectionRoute,
  };

const AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdRouteRouteWithChildren =
  AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdRouteRoute._addFileChildren(
    AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdRouteRouteChildren,
  );

interface AuthenticatedDashboardAccountsAccountIdHybridCloudRouteRouteChildren {
  AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdRouteRoute: typeof AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdRouteRouteWithChildren;
  AuthenticatedDashboardAccountsAccountIdHybridCloudAccessRoute: typeof AuthenticatedDashboardAccountsAccountIdHybridCloudAccessRoute;
  AuthenticatedDashboardAccountsAccountIdHybridCloudCreateRoute: typeof AuthenticatedDashboardAccountsAccountIdHybridCloudCreateRoute;
}

const AuthenticatedDashboardAccountsAccountIdHybridCloudRouteRouteChildren: AuthenticatedDashboardAccountsAccountIdHybridCloudRouteRouteChildren =
  {
    AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdRouteRoute:
      AuthenticatedDashboardAccountsAccountIdHybridCloudHybridCloudEnvIdRouteRouteWithChildren,
    AuthenticatedDashboardAccountsAccountIdHybridCloudAccessRoute:
      AuthenticatedDashboardAccountsAccountIdHybridCloudAccessRoute,
    AuthenticatedDashboardAccountsAccountIdHybridCloudCreateRoute:
      AuthenticatedDashboardAccountsAccountIdHybridCloudCreateRoute,
  };

const AuthenticatedDashboardAccountsAccountIdHybridCloudRouteRouteWithChildren =
  AuthenticatedDashboardAccountsAccountIdHybridCloudRouteRoute._addFileChildren(
    AuthenticatedDashboardAccountsAccountIdHybridCloudRouteRouteChildren,
  );

interface AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameRouteRouteChildren {
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameInfoRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameInfoRoute;
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameMetricsRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameMetricsRoute;
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNamePointsRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNamePointsRoute;
}

const AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameRouteRouteChildren: AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameRouteRouteChildren =
  {
    AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameInfoRoute:
      AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameInfoRoute,
    AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameMetricsRoute:
      AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameMetricsRoute,
    AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNamePointsRoute:
      AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNamePointsRoute,
  };

const AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameRouteRouteWithChildren =
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameRouteRoute._addFileChildren(
    AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameRouteRouteChildren,
  );

interface AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsRouteRouteChildren {
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameRouteRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameRouteRouteWithChildren;
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsIndexRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsIndexRoute;
}

const AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsRouteRouteChildren: AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsRouteRouteChildren =
  {
    AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameRouteRoute:
      AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsCollectionNameRouteRouteWithChildren,
    AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsIndexRoute:
      AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsIndexRoute,
  };

const AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsRouteRouteWithChildren =
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsRouteRoute._addFileChildren(
    AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsRouteRouteChildren,
  );

interface AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsRouteChildren {
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsRouteRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsRouteRouteWithChildren;
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsApiKeysRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsApiKeysRoute;
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsBackupsRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsBackupsRoute;
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsMetricsRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsMetricsRoute;
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsOverviewRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsOverviewRoute;
}

const AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsRouteChildren: AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsRouteChildren =
  {
    AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsRouteRoute:
      AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsCollectionsRouteRouteWithChildren,
    AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsApiKeysRoute:
      AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsApiKeysRoute,
    AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsBackupsRoute:
      AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsBackupsRoute,
    AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsMetricsRoute:
      AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsMetricsRoute,
    AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsOverviewRoute:
      AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsOverviewRoute,
  };

const AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsRouteWithChildren =
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsRoute._addFileChildren(
    AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsRouteChildren,
  );

interface AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdRouteRouteChildren {
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsRouteWithChildren;
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdCreateCollectionRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdCreateCollectionRoute;
}

const AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdRouteRouteChildren: AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdRouteRouteChildren =
  {
    AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsRoute:
      AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdTabsRouteWithChildren,
    AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdCreateCollectionRoute:
      AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdCreateCollectionRoute,
  };

const AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdRouteRouteWithChildren =
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdRouteRoute._addFileChildren(
    AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdRouteRouteChildren,
  );

interface AuthenticatedDashboardAccountsAccountIdServerlessSpacesRouteRouteChildren {
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdRouteRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdRouteRouteWithChildren;
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesCreateRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesCreateRoute;
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesIndexRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesIndexRoute;
}

const AuthenticatedDashboardAccountsAccountIdServerlessSpacesRouteRouteChildren: AuthenticatedDashboardAccountsAccountIdServerlessSpacesRouteRouteChildren =
  {
    AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdRouteRoute:
      AuthenticatedDashboardAccountsAccountIdServerlessSpacesSpaceIdRouteRouteWithChildren,
    AuthenticatedDashboardAccountsAccountIdServerlessSpacesCreateRoute:
      AuthenticatedDashboardAccountsAccountIdServerlessSpacesCreateRoute,
    AuthenticatedDashboardAccountsAccountIdServerlessSpacesIndexRoute:
      AuthenticatedDashboardAccountsAccountIdServerlessSpacesIndexRoute,
  };

const AuthenticatedDashboardAccountsAccountIdServerlessSpacesRouteRouteWithChildren =
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesRouteRoute._addFileChildren(
    AuthenticatedDashboardAccountsAccountIdServerlessSpacesRouteRouteChildren,
  );

interface AuthenticatedDashboardAccountsAccountIdRouteRouteChildren {
  AuthenticatedDashboardAccountsAccountIdCloudAccessRouteRoute: typeof AuthenticatedDashboardAccountsAccountIdCloudAccessRouteRouteWithChildren;
  AuthenticatedDashboardAccountsAccountIdClustersRouteRoute: typeof AuthenticatedDashboardAccountsAccountIdClustersRouteRouteWithChildren;
  AuthenticatedDashboardAccountsAccountIdHybridCloudRouteRoute: typeof AuthenticatedDashboardAccountsAccountIdHybridCloudRouteRouteWithChildren;
  AuthenticatedDashboardAccountsAccountIdServerlessSpacesRouteRoute: typeof AuthenticatedDashboardAccountsAccountIdServerlessSpacesRouteRouteWithChildren;
  AuthenticatedDashboardAccountsAccountIdBackupsRoute: typeof AuthenticatedDashboardAccountsAccountIdBackupsRoute;
  AuthenticatedDashboardAccountsAccountIdBillingRoute: typeof AuthenticatedDashboardAccountsAccountIdBillingRoute;
  AuthenticatedDashboardAccountsAccountIdSettingsRoute: typeof AuthenticatedDashboardAccountsAccountIdSettingsRoute;
}

const AuthenticatedDashboardAccountsAccountIdRouteRouteChildren: AuthenticatedDashboardAccountsAccountIdRouteRouteChildren =
  {
    AuthenticatedDashboardAccountsAccountIdCloudAccessRouteRoute:
      AuthenticatedDashboardAccountsAccountIdCloudAccessRouteRouteWithChildren,
    AuthenticatedDashboardAccountsAccountIdClustersRouteRoute:
      AuthenticatedDashboardAccountsAccountIdClustersRouteRouteWithChildren,
    AuthenticatedDashboardAccountsAccountIdHybridCloudRouteRoute:
      AuthenticatedDashboardAccountsAccountIdHybridCloudRouteRouteWithChildren,
    AuthenticatedDashboardAccountsAccountIdServerlessSpacesRouteRoute:
      AuthenticatedDashboardAccountsAccountIdServerlessSpacesRouteRouteWithChildren,
    AuthenticatedDashboardAccountsAccountIdBackupsRoute:
      AuthenticatedDashboardAccountsAccountIdBackupsRoute,
    AuthenticatedDashboardAccountsAccountIdBillingRoute:
      AuthenticatedDashboardAccountsAccountIdBillingRoute,
    AuthenticatedDashboardAccountsAccountIdSettingsRoute:
      AuthenticatedDashboardAccountsAccountIdSettingsRoute,
  };

const AuthenticatedDashboardAccountsAccountIdRouteRouteWithChildren =
  AuthenticatedDashboardAccountsAccountIdRouteRoute._addFileChildren(
    AuthenticatedDashboardAccountsAccountIdRouteRouteChildren,
  );

interface AuthenticatedDashboardRouteChildren {
  AuthenticatedDashboardSecurityRouteRoute: typeof AuthenticatedDashboardSecurityRouteRouteWithChildren;
  AuthenticatedDashboardGetStartedRoute: typeof AuthenticatedDashboardGetStartedRoute;
  AuthenticatedDashboardInvitationsRoute: typeof AuthenticatedDashboardInvitationsRoute;
  AuthenticatedDashboardPreferencesRoute: typeof AuthenticatedDashboardPreferencesRoute;
  AuthenticatedDashboardAccountsAccountIdRouteRoute: typeof AuthenticatedDashboardAccountsAccountIdRouteRouteWithChildren;
  AuthenticatedDashboardAuthCallbackRoute: typeof AuthenticatedDashboardAuthCallbackRoute;
  AuthenticatedDashboardAccountsIndexRoute: typeof AuthenticatedDashboardAccountsIndexRoute;
}

const AuthenticatedDashboardRouteChildren: AuthenticatedDashboardRouteChildren =
  {
    AuthenticatedDashboardSecurityRouteRoute:
      AuthenticatedDashboardSecurityRouteRouteWithChildren,
    AuthenticatedDashboardGetStartedRoute:
      AuthenticatedDashboardGetStartedRoute,
    AuthenticatedDashboardInvitationsRoute:
      AuthenticatedDashboardInvitationsRoute,
    AuthenticatedDashboardPreferencesRoute:
      AuthenticatedDashboardPreferencesRoute,
    AuthenticatedDashboardAccountsAccountIdRouteRoute:
      AuthenticatedDashboardAccountsAccountIdRouteRouteWithChildren,
    AuthenticatedDashboardAuthCallbackRoute:
      AuthenticatedDashboardAuthCallbackRoute,
    AuthenticatedDashboardAccountsIndexRoute:
      AuthenticatedDashboardAccountsIndexRoute,
  };

const AuthenticatedDashboardRouteWithChildren =
  AuthenticatedDashboardRoute._addFileChildren(
    AuthenticatedDashboardRouteChildren,
  );

interface AuthenticatedRouteChildren {
  AuthenticatedOnboardingRouteRoute: typeof AuthenticatedOnboardingRouteRouteWithChildren;
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRouteWithChildren;
  AuthenticatedOauthConsentRoute: typeof AuthenticatedOauthConsentRoute;
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedOnboardingRouteRoute:
    AuthenticatedOnboardingRouteRouteWithChildren,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRouteWithChildren,
  AuthenticatedOauthConsentRoute: AuthenticatedOauthConsentRoute,
};

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  authLoginRoute: authLoginRoute,
  authLogoutRoute: authLogoutRoute,
  authSignupRoute: authSignupRoute,
  publicCalculatorRoute: publicCalculatorRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
